<template>
    <div
        :class="{
            'mg-container': !fullColumn,
            'mobile-no-margin': mobileNoMargin
        }"
        :style="{
            ...containerStyle,
            'padding-top': noPadding ? '' : paddingTop,
            'margin-bottom': noMargin ? '' : marginBottom
        }"
    >
        <slot></slot>
    </div>
</template>

<script>
/**
 *  This component handles site How the modules are laid out on the page ,  spacing and such
 */
import { mapState } from 'vuex';
import { normal } from '../../modules/defaultSpacing';
const { topSpacing, btmSpacing, mobileTopSpacing, mobileBtmSpacing } = normal;
export default {
    computed: {
        ...mapState({
            isMobileSize: state => state.common.isMobileSize
        }),
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        }
    },
    props: {
        fullColumn: {
            type: Boolean,
            default: false
        },
        topSpacing: {
            default: topSpacing
        },
        btmSpacing: {
            default: btmSpacing
        },
        mobileTopSpacing: {
            default: mobileTopSpacing
        },
        mobileBtmSpacing: {
            default: mobileBtmSpacing
        },
        //  Do not apply top and bottom margins
        noPadding: {
            type: Boolean,
            default: false
        },
        noMargin: {
            type: Boolean,
            default: false
        },
        mobileNoMargin: {
            type: Boolean,
            default: false
        },
        containerStyle: {
            type: Object,
            default: undefined
        }
    }
};
</script>
